export interface Doctor {
  key?: number;
  id?: number;
  email: string;
  emailConfirmed?: boolean;
  medicalStudioId?: number;
  name?: string;
  surname?: string;
  studioMaster: boolean;
  telephone?: string;
  username: string;
  website?: string;
  password?: string;
  passwordConfirmation?: string;
  newPassword?: string; // Aggiungi questa se vuoi gestire una nuova password
  studio?: string; // Aggiungi questa per lo studio
}

export const emptyDoctor: Doctor = {
  studio: "",
  name: "",
  surname: "",
  email: "",
  password: "",
  telephone: "",
  emailConfirmed: false,
  studioMaster: false,
  username: "",
};

export function instanceOfDoctor(object: any): object is Doctor {
  return "id" in object && "email" in object && "username" in object;
}
